import { defaultLocales } from "locale"

const trimPattern = /\.0+$/
export const rollupMaps = {
  default: {
    [1000 * 1000 * 1000]: "b",
    [1000 * 1000]: "m",
    1000: "k",
  },

  bytes: {
    [1024 * 1024 * 1024]: "Gb",
    [1024 * 1024]: "Mb",
    1024: "Kb",
  },
}

export default function format(
  value,
  { locales, rollup, currency, precision, percent, trim } = {}
) {
  const options = {}

  if (currency) {
    options.style = "currency"
    options.currency = currency
  } else if (percent) {
    options.style = "percent"
  }

  let suffix
  if (rollup) {
    if (precision === undefined) {
      precision = 1
    }

    if (trim === undefined) {
      trim = true
    }

    ({ value, suffix } = rollupValue(value, rollup))
  }

  if (precision === false) {
    options.minimumFractionDigits = 0
    options.maximumFractionDigits = 20
  } else if (precision !== undefined) {
    options.minimumFractionDigits = precision
    options.maximumFractionDigits = precision
  }

  let formatted = Intl.NumberFormat(locales || defaultLocales, options).format(value)

  if (trim) {
    formatted = formatted.replace(trimPattern, "")
  }

  if (suffix) {
    formatted += suffix
  }

  return formatted
}

export function rollupValue(value, map) {
  if (map === true) {
    map = rollupMaps["default"]
  } else if (typeof map === "string") {
    map = rollupMaps[map]
  }

  let result = { value }
  for (const scale in map) {
    if (value >= scale) {
      result = { value: value / scale, suffix: map[scale] }
    }
  }

  return result
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Number/format.js